<template>
  <v-row dense>
    <v-col cols="12">
      <a-civilite-select
        dense
        label="Civilité"
        v-model="civilite"
        filled
        :rules="[requiredRule(), serverRule('civilite')]"
        @input="notify('civilite')"
        data-testid="civilite"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Nom"
        v-model="nom"
        filled
        :rules="[requiredRule(), serverRule('nom')]"
        @input="notify('nom')"
        data-testid="nom"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Prénom"
        v-model="prenom"
        filled
        :rules="[requiredRule(), serverRule('prenom')]"
        @input="notify('prenom')"
        data-testid="prenom"
      />
    </v-col>
     <v-col cols="12">
      <v-text-field
        dense
        label="Adresse"
        v-model="adresse"
        filled
        :rules="[serverRule('adresse')]"
        @input="notify('adresse')"
        placeholder="Facultatif"
        data-testid="adresse"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Complément d'adresse"
        v-model="complementAdresse"
        filled
        :rules="[serverRule('complementAdresse')]"
        @input="notify('complementAdresse')"
        placeholder="Facultatif"
        data-testid="complement-adresse"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Code postal"
        v-model="codePostal"
        filled
        :rules="[serverRule('codePostal')]"
        @input="notify('codePostal')"
        placeholder="Facultatif"
        data-testid="code-postal"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        dense
        label="Commune"
        v-model="ville"
        filled
        :rules="[serverRule('ville')]"
        @input="notify('ville')"
        placeholder="Facultatif"
        data-testid="commune"
      />
    </v-col>
  </v-row>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";

function mapTo(src, dest) {
  dest.nom = src.nom;
  dest.prenom = src.prenom;
  dest.civilite = src.civilite;
  dest.adresse = src.adresse;
  dest.complementAdresse = src.complementAdresse;
  dest.codePostal = src.codePostal;
  dest.ville = src.ville;
}

export default {
  mixins: [makeRules(), makeValueData(mapTo), ValueDataRules],
};
</script>
